var map = {
	"./ar/devices.json": 77116,
	"./ar/erp.json": 57938,
	"./ar/units.json": 848,
	"./de/devices.json": 21648,
	"./de/erp.json": 51518,
	"./de/units.json": 86284,
	"./en/devices.json": 11716,
	"./en/erp.json": 62250,
	"./en/units.json": 99304,
	"./es/devices.json": 91327,
	"./es/erp.json": 66677,
	"./es/units.json": 37155,
	"./fr/devices.json": 80099,
	"./fr/erp.json": 79953,
	"./fr/units.json": 73631,
	"./it/devices.json": 29626,
	"./it/erp.json": 3960,
	"./it/units.json": 95042,
	"./ja/devices.json": 27714,
	"./ja/erp.json": 78192,
	"./ja/units.json": 85466,
	"./ru/devices.json": 23278,
	"./ru/erp.json": 31604,
	"./ru/units.json": 55726,
	"./tr/devices.json": 47869,
	"./tr/erp.json": 66131,
	"./tr/units.json": 28829,
	"./zh/devices.json": 43001,
	"./zh/erp.json": 56631,
	"./zh/units.json": 25617
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93187;